import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RetainedView } from 'api/fragments';
import { UserApi } from 'api';
import store from 'store';
import { singlePageRoutes } from './SinglePageRoutes';
import { sharedRoutes } from '_legacy/models/SharedRoutes';
import { useAppDispatch } from 'store/hooks';
import { setRetainedView } from 'store/feature/userSlice';

export const RouteRetainer: React.FC = () => {
    const location = useHistory();
    const dispatch = useAppDispatch();

    const updatRetainedView = (groupId, newRetainedView: RetainedView) => {
        dispatch(setRetainedView(newRetainedView));
        UserApi.updateRetainedAppState(newRetainedView, groupId);
    };

    useEffect(() => {
        const retainView = (actualPath: string) => {
            const user = store.getState().user;
            const groupId = user.group?.id;
            if (groupId) {
                switch (actualPath) {
                    case singlePageRoutes.fixtures:
                        updatRetainedView(groupId, RetainedView.Fixtures);
                        break;

                    case singlePageRoutes.orders:
                        updatRetainedView(groupId, RetainedView.Orders);
                        break;

                    case sharedRoutes.multi:
                        updatRetainedView(groupId, RetainedView.Multi);
                        break;

                    default:
                        break;
                }
            }
        };
        retainView(location.location.pathname);
    }, [location.location]);

    return <></>;
};
